"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTopicForm = validateTopicForm;

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

/**
 * Validates a topic form and returns validation errors
 * @param {Object} formData - Form data to validate
 * @param {Object} options - Validation options and messages
 * @returns {Array} Array of error messages
 */
function validateTopicForm(formData, options) {
  var titlePhrase = options.titlePhrase,
      contentPhrase = options.contentPhrase,
      categoryPhrase = options.categoryPhrase,
      tagsRequired = options.tagsRequired,
      tagsPhrase = options.tagsPhrase,
      productAreasRequiredPhrase = options.productAreasRequiredPhrase,
      showProductAreas = options.showProductAreas,
      categoriesV2Ideation = options.categoriesV2Ideation,
      showCategoriesForIdeas = options.showCategoriesForIdeas;
  var validations = [{
    condition: !formData.title || formData.title.trim() === '',
    message: titlePhrase
  }, {
    condition: !_htmlParser.default.hasContent(formData.content),
    message: contentPhrase
  }, {
    condition: !showCategoriesForIdeas && !formData.category,
    message: categoryPhrase
  }, {
    condition: showCategoriesForIdeas && categoriesV2Ideation && !formData.categoryId,
    message: categoryPhrase
  }, {
    condition: showProductAreas && (!formData.productAreaIds || formData.productAreaIds.length === 0),
    message: productAreasRequiredPhrase
  }, {
    condition: tagsRequired && (!formData.tags || formData.tags.length === 0),
    message: tagsPhrase
  }];
  var errors = [];
  validations.forEach(function (validation) {
    if (validation.condition) {
      errors.push(validation.message);
    }
  });
  return errors;
}